import React, { useEffect, useState, useRef } from 'react';
import { FaSignOutAlt, FaBars, FaUserCircle, FaEdit, FaTrash, FaPlus, FaHome, FaCheck } from 'react-icons/fa';
import { MdCategory, MdDashboard, MdInventory, MdPhotoLibrary } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AdminDashboard = () => {
  const adminEmail = sessionStorage.getItem('adminEmail');
  const navigate = useNavigate();
   const [categories, setCategories] = useState([]);
  const [loadingC, setLoadingC] = useState(true);
  const [formData, setFormData] = useState({ name: '', image_url: '' });
  const [editingId, setEditingId] = useState(null);

const [items, setItems] = useState([]);
  const [loadingS, setLoadingS] = useState(true);
  const [formDataS, setFormDataS] = useState({ title: '', image: null });
  const [editingIds, setEditingIds] = useState(null);

  // Fetch Slider Items
  const fetchItemss = async () => {
    try {
      const res = await axios.get('https://api.lbnhyderabad.com/auth-mp/api/sliders');
      setItems(res.data);
    } catch (err) {
      console.error('Error fetching slider items:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItemss();
  }, []);


    const [PItems, setPItems] = useState([]);
  const [loading, setLoading] = useState(true);

  // Sidebar / navigation items
  const allNavItems = [
    { label: 'Dashboard', icon: <MdDashboard /> },
    {label:'Product Requirement', icon:<MdInventory /> },
     { label: 'Product', icon: <MdCategory /> },
       { label: 'Slider Items', icon: <MdPhotoLibrary /> }

  ];

  const [activeComponent, setActiveComponent] = useState(
    localStorage.getItem('activeComponent') || allNavItems[0].label
  );
  useEffect(() => {
    localStorage.setItem('activeComponent', activeComponent);
  }, [activeComponent]);

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

  // Data / modal states
  
  // Top header profile menu
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const profileMenuRef = useRef(null);

  const handleToggleProfileMenu = () => setShowProfileMenu((prev) => !prev);

  // Close profile menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(e.target)) {
        setShowProfileMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  



  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/admin-login');
  };

  //......Product Requirement .....//



  const fetchItems = async () => {
    try {
      const res = await axios.get('https://api.lbnhyderabad.com/auth-mp/api/productRequirements');
      setPItems(res.data);
    } catch (err) {
      console.error('Error fetching product requirements:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchItems();
  }, []);

  
  const fetchCategories = async () => {
    try {
      const res = await axios.get('https://api.lbnhyderabad.com/auth-mp/api/categories');
      setCategories(res.data);
    } catch (err) {
      console.error('Error fetching categories:', err);
    } finally {
      setLoading(false);
    }
  };

    useEffect(() => {
    fetchCategories();
  }, []);

  const handleApprove = async (id) => {
    try {
      await axios.patch(`https://api.lbnhyderabad.com/auth-mp/api/productRequirements/${id}/status`, { status: 'Approved' });
      // update locally
      setPItems(PItems.map(it => it.id === id ? { ...it, status: 'Approved' } : it));
    } catch (err) {
      console.error('Error approving item:', err);
      alert('Approval failed');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this requirement?')) return;
    try {
      await axios.delete(`https://api.lbnhyderabad.com/auth-mp/api/productRequirements/${id}`);
      setPItems(PItems.filter(it => it.id !== id));
    } catch (err) {
      console.error('Error deleting item:', err);
      alert('Delete failed');
    }
  };

  if (loading) {
    return <div>Loading product requirements …</div>;
  }



 // Handle add/update category
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = new FormData();
      data.append('name', formData.name);
      if (formData.image) data.append('image', formData.image);

      if (editingId) {
        // PUT (Update existing)
        await axios.put(
          `https://api.lbnhyderabad.com/auth-mp/api/categories/${editingId}`,
          data,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        fetchCategories();
        setEditingId(null);
      } else {
        // POST (Create new)
        await axios.post(
          'https://api.lbnhyderabad.com/auth-mp/api/categories',
          data,
          { headers: { 'Content-Type': 'multipart/form-data' } }
        );
        fetchCategories();
      }

      // Reset form
      setFormData({ name: '', image: null });
      document.getElementById('imageInput').value = '';
    } catch (err) {
      console.error('Error saving category:', err);
      alert('Failed to save category');
    }
  };

  const handleEdit = (cat) => {
    setFormData({ name: cat.name, image: null });
    setEditingId(cat.id);
  };

  const handleDeleteC = async (id) => {
    if (!window.confirm('Are you sure you want to delete this category?')) return;
    try {
      await axios.delete(`https://api.lbnhyderabad.com/auth-mp/api/categories/${id}`);
      setCategories(categories.filter(c => c.id !== id));
    } catch (err) {
      console.error('Error deleting category:', err);
      alert('Delete failed');
    }
  };


   const handleSubmitS = async (e) => {
    e.preventDefault();
    try {
      const data = new FormData();
   
      if (formDataS.image) data.append('image', formDataS.image);

      if (editingIds) {
        // Update
        await axios.put(`https://api.lbnhyderabad.com/auth-mp/api/sliders/${editingIds}`, data, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
      } else {
        // Add
        await axios.post('https://api.lbnhyderabad.com/auth-mp/api/sliders', data, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
      }

      fetchItemss();
      setFormDataS({ title: '', image: null });
      setEditingId(null);
      document.getElementById('sliderImageInput').value = '';
    } catch (err) {
      console.error('Error saving slider item:', err);
      alert('Failed to save slider item');
    }
  };

  const handleEdits = (item) => {
    setFormDataS({ title: item.title, image: null });
    setEditingIds(item.id);
  };

  const handleDeletes = async (id) => {
    if (!window.confirm('Are you sure you want to delete this slider item?')) return;
    try {
      await axios.delete(`https://api.lbnhyderabad.com/auth-mp/api/sliders/${id}`);
      setItems(items.filter((item) => item.id !== id));
    } catch (err) {
      console.error('Error deleting slider item:', err);
      alert('Delete failed');
    }
  };

  if (loading) return <div>Loading slider items...</div>;


  if (loading) return <div>Loading categories...</div>;


  const renderContent = () => {
    if (activeComponent === 'Product Requirement') {
      return (
  <div style={{ padding: 20, backgroundColor: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
      <h2 style={{ marginBottom: 20, color: '#025299' }}>Product Requirements</h2>
      {PItems.length === 0 ? (
        <p>No product requirements found.</p>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ccc' }}>
          <thead style={{ backgroundColor: '#025299', color: '#fff' }}>
            <tr>
              <th style={{ padding: 10, border: '1px solid #ccc' }}>#</th>
              <th style={{ padding: 10, border: '1px solid #ccc' }}>User</th>
              <th style={{ padding: 10, border: '1px solid #ccc' }}>Product Name</th>
              <th style={{ padding: 10, border: '1px solid #ccc' }}>City</th>
              <th style={{ padding: 10, border: '1px solid #ccc' }}>Image</th>
              <th style={{ padding: 10, border: '1px solid #ccc' }}>Description</th>
              <th style={{ padding: 10, border: '1px solid #ccc' }}>Status</th>
              <th style={{ padding: 10, border: '1px solid #ccc' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {PItems.map((it, idx) => (
              <tr key={it.id}>
                <td style={{ padding: 10, border: '1px solid #ddd' }}>{idx + 1}</td>
                <td style={{ padding: 10, border: '1px solid #ddd' }}>
                  {it.user_name || ''} <br />
                  <small>{it.user_email && it.user_mobile}</small>
                </td>
                <td style={{ padding: 10, border: '1px solid #ddd' }}>{it.product_name}</td>
                <td style={{ padding: 10, border: '1px solid #ddd' }}>{it.city}</td>
                <td style={{ padding: 10, border: '1px solid #ddd' }}>
                  {it.product_image && (
                    <img src={it.product_image} alt={it.product_name} style={{ width: 80, height: 'auto', borderRadius: 4 }} />
                  )}
                </td>
                <td style={{ padding: 10, border: '1px solid #ddd' }}>{it.product_description}</td>
                <td style={{ padding: 10, border: '1px solid #ddd' }}>{it.status}</td>
                <td style={{ padding: 10, border: '1px solid #ddd' }}>
                  {it.status !== 'Approved' && (
                    <button onClick={() => handleApprove(it.id)} style={{ marginRight: 8, backgroundColor: '#025299', color: '#fff', padding: '6px 12px', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
                      <FaCheck style={{ marginRight: 4 }} /> Approve
                    </button>
                  )}
                  <button onClick={() => handleDelete(it.id)} style={{ backgroundColor: '#faae2f', color: '#fff', padding: '6px 12px', border: 'none', borderRadius: 4, cursor: 'pointer' }}>
                    <FaTrash style={{ marginRight: 4 }} /> Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
      );
    }

    if (activeComponent === 'Logout') {
      return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
          <h2>You are logged out</h2>
          <button onClick={handleLogout} style={contentStyles.addBtn}>
            Logout
          </button>
        </div>
      );
    }


      if (activeComponent === 'Slider Items') {
    return (
         <div style={{ padding: 20, backgroundColor: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
      <h2 style={{ marginBottom: 20, color: '#025299' }}>Slider Item Management</h2>

      {/* Add/Edit Form */}
      <form onSubmit={handleSubmitS} style={{ marginBottom: 20, display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
      
        <input
          type="file"
          id="sliderImageInput"
          accept="image/*"
          onChange={(e) => setFormDataS({ ...formData, image: e.target.files[0] })}
          style={{
            padding: '8px',
            width: '300px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            cursor: 'pointer',
          }}
        />
        <button
          type="submit"
          style={{
            backgroundColor: '#025299',
            color: '#fff',
            padding: '8px 16px',
            border: 'none',
            borderRadius: 4,
            cursor: 'pointer',
          }}
        >
          {editingId ? 'Update' : 'Add'}
        </button>
      </form>

      {/* Table */}
      {items.length === 0 ? (
        <p>No slider items found.</p>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ccc' }}>
          <thead style={{ backgroundColor: '#025299', color: '#fff' }}>
            <tr>
              <th style={{ padding: 10, border: '1px solid #ccc' }}>#</th>
        
              <th style={{ padding: 10, border: '1px solid #ccc' }}>Image</th>
              <th style={{ padding: 10, border: '1px solid #ccc' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, idx) => (
              <tr key={item.id}>
                <td style={{ padding: 10, border: '1px solid #ddd' }}>{idx + 1}</td>
             
                <td style={{ padding: 10, border: '1px solid #ddd' }}>
                  {item.image_url && <img src={item.image_url} alt={item.title} style={{ width: 80, height: 'auto', borderRadius: 4 }} />}
                </td>
                <td style={{ padding: 10, border: '1px solid #ddd' }}>
                  {/* <button
                    onClick={() => handleEdits(item)}
                    style={{
                      marginRight: 8,
                      backgroundColor: '#025299',
                      color: '#fff',
                      padding: '6px 12px',
                      border: 'none',
                      borderRadius: 4,
                      cursor: 'pointer',
                    }}
                  >
                    Edit
                  </button> */}
                  <button
                    onClick={() => handleDeletes(item.id)}
                    style={{
                      backgroundColor: '#faae2f',
                      color: '#fff',
                      padding: '6px 12px',
                      border: 'none',
                      borderRadius: 4,
                      cursor: 'pointer',
                    }}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
    );
  }


    if (activeComponent === 'Product') {
  return (
 <div style={{ padding: 20, backgroundColor: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
      <h2 style={{ marginBottom: 20, color: '#025299' }}>Product Management</h2>

      {/* Add/Edit Form */}
<form onSubmit={handleSubmit} style={{ marginBottom: 20, display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
  <input
    type="text"
    placeholder="Product Name"
    value={formData.name}
    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
    required
    style={{ padding: '8px', width: '200px' }}
  />
<input
  type="file"
  id="imageInput"
  accept="image/*"
  onChange={(e) => setFormData({ ...formData, image: e.target.files[0] })}
  style={{
    padding: '8px',
    width: '300px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    cursor: 'pointer'
  }}
/>

  <button
    type="submit"
    style={{
      backgroundColor: '#025299',
      color: '#fff',
      padding: '8px 16px',
      border: 'none',
      borderRadius: 4,
    }}
  >
    <FaPlus style={{ marginRight: 4 }} /> {editingId ? 'Update' : 'Add'}
  </button>
</form>

      {/* Table */}
      {categories.length === 0 ? (
        <p>No categories found.</p>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ccc' }}>
          <thead style={{ backgroundColor: '#025299', color: '#fff' }}>
            <tr>
              <th style={{ padding: 10, border: '1px solid #ccc' }}>#</th>
              <th style={{ padding: 10, border: '1px solid #ccc' }}>Name</th>
              <th style={{ padding: 10, border: '1px solid #ccc' }}>Image</th>
              <th style={{ padding: 10, border: '1px solid #ccc' }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {categories.map((cat, idx) => (
              <tr key={cat.id}>
                <td style={{ padding: 10, border: '1px solid #ddd' }}>{idx + 1}</td>
                <td style={{ padding: 10, border: '1px solid #ddd' }}>{cat.name}</td>
                <td style={{ padding: 10, border: '1px solid #ddd' }}>
                  {cat.image_url && (
                    <img
                      src={cat.image_url}
                      alt={cat.name}
                      style={{ width: 80, height: 'auto', borderRadius: 4 }}
                    />
                  )}
                </td>
                <td style={{ padding: 10, border: '1px solid #ddd' }}>
                  <button
                    onClick={() => handleEdit(cat)}
                    style={{
                      marginRight: 8,
                      backgroundColor: '#025299',
                      color: '#fff',
                      padding: '6px 12px',
                      border: 'none',
                      borderRadius: 4,
                    }}
                  >
                    <FaEdit style={{ marginRight: 4 }} /> Edit
                  </button>
                  <button
                    onClick={() => handleDeleteC(cat.id)}
                    style={{
                      backgroundColor: '#faae2f',
                      color: '#fff',
                      padding: '6px 12px',
                      border: 'none',
                      borderRadius: 4,
                    }}
                  >
                    <FaTrash style={{ marginRight: 4 }} /> Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}


    // Dashboard or default
    return (
      <div style={{ padding: '20px' }}>
        <h2>Welcome, {adminEmail}</h2>
        <p>This is your admin dashboard home.</p>
      </div>
    );
  };

  return (
    <div style={baseStyles.container}>
      {/* Sidebar */}
      <div style={{ ...baseStyles.sidebar, width: sidebarOpen ? '210px' : '60px' }}>
        {/* <button onClick={toggleSidebar} style={baseStyles.sidebarToggle}>
          <FaBars color="white" />
        </button> */}
        <div style={baseStyles.logoArea}>
          {sidebarOpen ? (
            <span style={{ color: '#faae2f', fontWeight: 'bold', fontSize: '20px' }}>LBN Admin</span>
          ) : (
            <span style={{ color: '#faae2f', fontSize: '20px' }}>L</span>
          )}
        </div>
    <nav style={{ marginTop: '20px' }}>
  {allNavItems.map((item) => (
    <div
      key={item.label}
      style={{
        ...baseStyles.navItem,
        display: 'flex',
        alignItems: 'center',
        padding: '12px 16px',
        cursor: 'pointer',
        borderRadius: '6px',
        marginBottom: '8px',
        color: activeComponent === item.label ? '#faae2f' : '#fff',
        backgroundColor: activeComponent === item.label ? '#025299' : 'transparent',
        transition: 'background-color 0.2s ease',
      }}
      onClick={() => {
        if (item.label === 'Logout') {
          handleLogout();
        } else {
          setActiveComponent(item.label);
        }
      }}
      onMouseEnter={(e) => {
        if (activeComponent !== item.label) {
          e.currentTarget.style.backgroundColor = '#faae2f';
        }
      }}
      onMouseLeave={(e) => {
        if (activeComponent !== item.label) {
          e.currentTarget.style.backgroundColor = 'transparent';
        }
      }}
    >
      <div style={{ marginRight: sidebarOpen ? '10px' : '0', display: 'flex', alignItems: 'center' }}>
        {item.icon}
      </div>
      {sidebarOpen && <span style={baseStyles.navLabel}>{item.label}</span>}
    </div>
  ))}
</nav>

      </div>

      {/* Main area */}
      <div style={baseStyles.mainArea(sidebarOpen)}>
        {/* Top header */}
        <div style={headerStyles.header}>
         <div style={headerStyles.leftGroup}>
  <button onClick={toggleSidebar} style={headerStyles.toggleBtn}>
    <FaBars color="#fff" />
  </button>
  <span style={{ color: '#025299', fontSize: '22px', fontWeight: 'bold' ,marginLeft:'5px'}}>LBN Market</span>
</div>

          <div style={headerStyles.profileArea} ref={profileMenuRef}>
            <FaUserCircle
              size={28}
              style={{ cursor: 'pointer', color: '#025299' }}
              onClick={handleToggleProfileMenu}
            />
            {showProfileMenu && (
              <div style={headerStyles.profileMenu}>
                <div style={headerStyles.profileMenuItem} onClick={handleLogout}>
                  <FaSignOutAlt style={{ marginRight: '8px' }} /> Logout
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Content */}
        <div style={baseStyles.contentWrapper}>{renderContent()}</div>
      </div>
    </div>
  );
};

export default AdminDashboard;

/** Style objects **/

const baseStyles = {
  container: {
    display: 'flex',
    height: '100vh',
    fontFamily: 'Segoe UI, sans-serif',
  },
  sidebar: {
    backgroundColor: '#025299',
    color: 'white',
    transition: 'width 0.3s',
    position: 'fixed',
    top: 0,
    bottom: 0,
    left: 0,
    overflow: 'hidden',
  },
  sidebarToggle: {
    position: 'absolute',
    top: '15px',
    right: '-15px',
    backgroundColor: '#faae2f',
    border: 'none',
    borderRadius: '50%',
    width: '30px',
    height: '30px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  logoArea: {
    padding: '20px 10px',
    textAlign: 'center',
  },
  leftGroup: {
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
},

toggleBtn: {
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer',
  fontSize: '20px',
  padding: '5px',
  marginRight:'8px'
},

  navItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '12px 16px',
    cursor: 'pointer',
    color: 'white',
  },
  navIcon: {
    fontSize: '18px',
    marginRight: '12px',
  },
  navLabel: {
    fontSize: '16px',
  },
  mainArea: (sidebarOpen) => ({
    marginLeft: sidebarOpen ? '220px' : '60px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  }),
  contentWrapper: {
    flex: 1,
    overflowY: 'auto',
    padding: '20px',
    backgroundColor: '#F7FAFC',
  },
};

const headerStyles = {
  header: {
    width: '98%',
    height: '60px',
    backgroundColor: 'white',
    borderBottom: '1px solid #E2E8F0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 20px',
  },
  logoLeft: {
    fontSize: '20px',
    fontWeight: 'bold',
  },
  profileArea: {
    position: 'relative',
  },
  profileMenu: {
    position: 'absolute',
    right: 0,
    top: 'calc(100% + 10px)',
    backgroundColor: 'white',
    border: '1px solid #E2E8F0',
    borderRadius: '6px',
    boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
    zIndex: 100,
  },
  profileMenuItem: {
    padding: '10px 20px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
  },
};

const contentStyles = {
  wrapper: { backgroundColor: 'white', padding: '20px', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' },
  headerRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  title: { margin: 0, fontSize: '22px', color: '#025299' },
  addBtn: {
    backgroundColor: '#faae2f',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    cursor: 'pointer',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
  },
table: {
  width: '100%',
  borderCollapse: 'collapse',
  border: '1px solid #ccc', // 👈 Add this line for border
  borderRadius: '6px',
  overflow: 'hidden',
  boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
},

  thead: { backgroundColor: '#025299', color: 'white' },
th: {
  padding: '10px',
  border: '1px solid #ccc',
  backgroundColor: '#025299',
  textAlign: 'left',
  fontWeight: '600',
  color: '#f7fafc',
},

td: {
  padding: '10px',
  border: '1px solid #ddd',
  color: '#4A5568',
},

  tr: { borderBottom: '1px solid #e2e8f0' },

  btnEdit: {
    backgroundColor: '#3182CE',
    color: 'white',
    border: 'none',
    padding: '6px 12px',
    marginRight: '8px',
    cursor: 'pointer',
    borderRadius: '4px',
  },
  btnDelete: {
    backgroundColor: '#E53E3E',
    color: 'white',
    border: 'none',
    padding: '6px 12px',
    cursor: 'pointer',
    borderRadius: '4px',
  },
  noData: { padding: '20px', textAlign: 'center', color: '#718096' },
};

const modalStyles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0,0,0,0.4)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
  },
  content: {
    backgroundColor: 'white',
    padding: '30px',
    width: '450px',
    borderRadius: '8px',
    boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
  },
  input: {
    width: '100%',
    padding: '10px',
    marginBottom: '14px',
    border: '1px solid #CBD5E0',
    borderRadius: '4px',
    fontSize: '14px',
  },
  btnSubmit: {
    backgroundColor: '#025299',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    cursor: 'pointer',
    borderRadius: '4px',
  },
  btnCancel: {
    backgroundColor: '#A0AEC0',
    color: 'white',
    border: 'none',
    padding: '8px 16px',
    marginLeft: '10px',
    cursor: 'pointer',
    borderRadius: '4px',
  },
};
